import { render, staticRenderFns } from "./OrdersSupplier.vue?vue&type=template&id=71244a22&scoped=true&"
import script from "./OrdersSupplier.vue?vue&type=script&lang=js&"
export * from "./OrdersSupplier.vue?vue&type=script&lang=js&"
import style0 from "./OrdersSupplier.vue?vue&type=style&index=0&id=71244a22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71244a22",
  null
  
)

export default component.exports